import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import FormField from "./FormField";

function FormText(props) {
  return (
    <FormField
      {...props}
      Field={TextField}
      fieldProps={({ value }) => ({
        type: props.textFieldType,
        value: value ?? "",
        multiline: props.rows > 1,
        rows: props.rows,
        ...props.fieldProps,
      })}
    />
  );
}

FormText.defaultProps = {
  rows: 1,
  textFieldType: "text",
  fieldProps: {},
};

export default FormText;
